import  {KeyWordSearchService}  from "./KeyWordSearchService";

/// <summary>
/// 关键字视野内搜索
/// </summary>
export class ViewKeyWordSearchService extends KeyWordSearchService {

	constructor() {
		super();
	}

	
}//end ViewKeyWordSearchService

